import { createBrowserRouter } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { ProtectedRoute } from '@/components';
import Home from '@/pages/Home';
import SagawaExp from '@/pages/SagawaExp';
import HanedaShop from '@/pages/HanedaShop';
import Vip from '@/pages/Vip';
import AITrip from '@/pages/AITrip';
import Orders from '@/pages/Orders';
import Coupon from '@/pages/Coupon/index';
import Profile from '@/pages/Profile';
import Protocol from '@/pages/Protocol';
import TermsOfService from '@/pages/TermsOfService';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import Items from '@/pages/Items';
import CouponList from '@/pages/Coupon/List/index';
import CouponDetail from '@/pages/Coupon/Detail/index';
import CouponPrecautions from '@/pages/Coupon/Precautions/index';
import AboutUs from '@/pages/AboutUs';


const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: '/airport-luggage-delivery',
        element: <SagawaExp />,
      },
      {
        path: '/duty-free-pre-order',
        element: <HanedaShop />,
      },
      {
        path: '/vip',
        element: <Vip />,
      },
      {
        path: '/ai-trip',
        element: <AITrip />,
      },
      {
        path: '/coupon',
        element: <Coupon />,
      },
      {
        path: '/coupon-list',
        element: <CouponList />,
      },
      {
        path: '/coupon-detail',
        element: <CouponDetail />,
      },
      {
        path: '/coupon-precautions',
        element: <CouponPrecautions />,
      },
      {
        path: '/orders',
        element: (
          <ProtectedRoute>
            <Orders />
          </ProtectedRoute>
        ),
      },
      {
        path: '/profile',
        element: (
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        ),
      },
      {
        path: '/terms',
        element: <TermsOfService />,
      },
      {
        path: '/privacy',
        element: <PrivacyPolicy />,
      },
      {
        path: '/items',
        element: <Items />,
      },
      {
        path: '/about-us',
        element: <AboutUs />,
      }
    ],
  },
  {
    path: '/protocol',
    element: <Protocol />,
  },
]);

export default router;
